// import { useAuthStore } from "@/store/auth";
import categoryRoute from "./categoryRoute";
import productRoute from "./productRoute";
import order from "./order";
import delivery from "./delivery";

export default [
  ...categoryRoute,
  ...productRoute,
  ...order,
  ...delivery,
  {
    path: "/",
    name: "login",
    component: () => import("@/views/auth/login.vue"),
    meta: {
      title: "Login",
      // beforeResolve(routeTo, routeFrom, next) {
      //   // If the user is already logged in
      //   if (useAuthStore().isLoggedIn) {
      //     // Redirect to the home page instead
      //     next({ name: "dashboard" });
      //   } else {
      //     // Continue to the login page
      //     next();
      //   }
      // },
    },
  },
  {
    path: "/pEG8A1krFX",
    name: "dashboard",
    meta: {
      title: "Dashboard",
      authRequired: true,
      // beforeResolve(routeTo, routeFrom, next) {
      //   next({name: "dashboard" });
      // },
    },
    component: () => import("@/views/dashboard/default"),
  },

  {
    path: "/cgvzl96QF9zV1ylVYK3U",
    name: "default",
    meta: {
      title: "Dashboard",
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        next({ name: "dashboard" });
        // Continue to the login page
      },
    },
    component: () => import("@/views/dashboard/default.vue"),
  },

  {
    path: "/ZfhIdxA",
    name: "account-dashboard",
    meta: {
      title: "Account Dashboard",
      authRequired: true,
      acc: ["y93422"],
    },
    component: () => import("@/views/dashboard/account/account-dashboard.vue"),
  },
  {
    path: "/pEG8A1krFXy609..",
    name: "reset-password",
    meta: {
      title: "Reset Password",
      authRequired: true,
    },
    component: () => import("@/views/auth/reset-password.vue"),
  },
  {
    path: "/XmyeVqbZfhIdxAqw78QX/:menu",
    name: "menu",
    meta: {
      title: "Menu List",
      authRequired: true,
      // acc: "admin",
    },
    component: () => import("@/components/menu-list.vue"),
  },
  {
    path: "/notfound",
    name: "notfound",
    meta: {
      title: "404",
      //
    },
    component: () => import("@/views/notfound/404-cover"),
  },
  // start of import
  {
    path: "/:pathMatch(.*)*",
    name: "not-found",
    meta: {
      title: "404",
      //
    },
    component: () => import("@/views/notfound/404-cover"),
  },
  // end of import
];
